import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-people-profile-help-modal',
  templateUrl: './people-profile-help-modal.component.pug',
  styleUrls: ['./people-profile-help-modal.component.scss'],
  standalone: false
})
export class PeopleProfileHelpModalComponent implements OnInit {

  constructor(
    public modalService: BsModalService,
  ) { }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.modalService.hide()
  }
}
